/* eslint-disable import/prefer-default-export */
import React from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

import { StoreType } from "client/store"

const LostConnectionWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    padding-top: 110px;
    z-index: 1000;
    background: ${(props) => props.theme.lostConnectionWrapperBackground};
`
const LostConnectionMessage = styled.div`
    width: 100%;
    height: fit-content;
    padding: 8px;
    text-align: center;
    background: ${(props) => props.theme.lostConnectionMessageBackground};
    color: ${(props) => props.theme.lostConnectionMessageColor};
`

export const LostConnection = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <LostConnectionWrapper>
            <LostConnectionMessage>
                {lang.lostServerConnection}
            </LostConnectionMessage>
        </LostConnectionWrapper>
    )
}
